import { Link, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';

interface MarkdownProps {
  children: string;
}

export const Markdown = ({ children }: MarkdownProps) => {
  return (
    <ReactMarkdown
      components={{
        h1: ({ children }) => (
          <Typography variant="h1" gutterBottom>
            {children}
          </Typography>
        ),
        h2: ({ children }) => (
          <Typography variant="h2" color="textPrimary" gutterBottom>
            {children}
          </Typography>
        ),
        a: ({ href, children }) => <Link href={href}>{children}</Link>,
        p: ({ children }) => (
          <Typography variant="body1" color="textPrimary" gutterBottom>
            {children}
          </Typography>
        ),
        li: ({ children }) => (
          <Typography component="li" variant="body1" color="textPrimary" gutterBottom>
            {children}
          </Typography>
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
